import { render } from "./FormNotice.vue?vue&type=template&id=8f60b4a4&scoped=true"
import script from "./FormNotice.vue?vue&type=script&lang=js"
export * from "./FormNotice.vue?vue&type=script&lang=js"

import "./FormNotice.vue?vue&type=style&index=0&id=8f60b4a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8f60b4a4"

export default script